import { Token } from 'types/portfolio'
import { Address } from 'viem'

interface TokenRowProps {
  address: Address
  token: Token | undefined
  balance: string
  balanceValue: number
  balanceFormatted: string
  balanceUSD: number
  balanceUSDFormatted: string
  price: number
  priceFormatted: string
  decimals: number
}

export function TokenRow({ token, priceFormatted, balanceFormatted, balanceUSDFormatted }: TokenRowProps) {
  return (
    <div className="border-b border-kodiak-border-secondary last:border-b-0 hover:bg-kodiak-hover-card transition-colors duration-200">
      {/* Mobile Layout */}
      <div className="sm:hidden px-3 py-2 space-y-3">
        <div className="grid grid-cols-[2fr_1fr_1fr] items-center">
          <div className="flex items-center gap-2 sm:gap-3">
            <div className="w-6 h-6 sm:w-8 sm:h-8 rounded-full bg-kodiak-card-secondary border border-kodiak-border-secondary flex items-center justify-center overflow-hidden">
              {token?.logoUri ? (
                <img
                  src={token.logoUri}
                  alt={token.symbol}
                  className="w-full h-full object-cover"
                  onError={(e) => {
                    const target = e.target as HTMLImageElement
                    target.style.display = 'none'
                    target.nextElementSibling?.classList.remove('hidden')
                  }}
                />
              ) : null}
              <div className={`text-xs font-medium text-kodiak-text-secondary ${token?.logoUri ? 'hidden' : ''}`}>
                {token?.symbol?.charAt(0) || '?'}
              </div>
            </div>
            <div className="flex flex-col gap-0.5">
              <div className="text-xs leading-none sm:text-base font-medium text-kodiak-text-primary">
                {token?.symbol || '-'}
              </div>
              <div className="text-[10px] leading-none text-kodiak-text-secondary">{balanceFormatted}</div>
            </div>
          </div>
          <div className="flex justify-between text-xs">
            <span className="text-kodiak-text-secondary">{priceFormatted}</span>
          </div>
          <div className="text-right">
            <div className="text-kodiak-text-primary font-medium text-sm">{balanceUSDFormatted}</div>
          </div>
        </div>
      </div>

      {/* Desktop Layout */}
      <div className="hidden sm:grid grid-cols-4 items-center py-2 px-6">
        {/* Token Info */}
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 rounded-full bg-kodiak-card-secondary border border-kodiak-border-secondary flex items-center justify-center overflow-hidden">
            {token?.logoUri ? (
              <img
                src={token.logoUri}
                alt={token.symbol}
                className="w-8 h-8 object-cover"
                onError={(e) => {
                  const target = e.target as HTMLImageElement
                  target.style.display = 'none'
                  target.nextElementSibling?.classList.remove('hidden')
                }}
              />
            ) : null}
            <div
              className={`text-xs font-medium text-[var(--color-kodiak-text-primary)] ${
                token?.logoUri ? 'hidden' : ''
              }`}
            >
              {token?.symbol?.charAt(0) || '?'}
            </div>
          </div>
          <div className="flex flex-col min-w-0 flex-1">
            <div className="font-medium text-kodiak-text-primary truncate">{token?.symbol || '-'}</div>
            <div className="text-xs text-kodiak-text-secondary truncate">{token?.name || '-'}</div>
          </div>
        </div>

        {/* Price */}
        <div className="text-kodiak-text-secondary font-normal">{priceFormatted}</div>

        {/* Amount */}
        <div className="text-kodiak-text-primary font-normal">{balanceFormatted}</div>

        {/* USD Value */}
        <div className="text-kodiak-text-primary font-medium text-right">{balanceUSDFormatted}</div>
      </div>
    </div>
  )
}
